/**
 * Sitewide storefront fixes for live Shopify Online Store.
 *
 * Fixes:
 * 1. Nav / footer / collection links: gift-boxes + byo-brats "Build Your Own" → builder
 * 2. BYO product PDP: replace ATC with link to builder (no blank boxes)
 * 3. Intercept cart/add for BYO variant without flavor properties
 * 4. Collection gift-boxes / byo-brats: redirect to builder
 * 5. Hide BYO helper cards on Shop by Category
 */
(function () {
  var BUILDER = '/pages/build-your-bundle';
  var BYO_VARIANT = '46488914755745';
  var GIFT_BOXES = '/collections/gift-boxes';
  var BYO_BRATS = '/collections/byo-brats';

  function isByoVariant(id) {
    if (id == null) return false;
    var s = String(id);
    return s === BYO_VARIANT || s.indexOf(BYO_VARIANT) !== -1 || s.indexOf('ProductVariant/' + BYO_VARIANT) !== -1;
  }

  function goBuilder(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    window.location.href = BUILDER;
  }

  function rewriteLinks() {
    document.querySelectorAll('a[href*="/collections/gift-boxes"], a[href*="/collections/byo-brats"]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var wantsBuilder =
        href.indexOf(GIFT_BOXES) !== -1 ||
        href.indexOf(BYO_BRATS) !== -1 ||
        label.indexOf('build your own') !== -1 ||
        label.indexOf('brat box') !== -1;
      if (wantsBuilder) a.setAttribute('href', BUILDER);
    });
  }

  function hideHelperCollectionCards() {
    if (!/\/collections\/?$/.test(window.location.pathname)) return;
    document.querySelectorAll('a.product-card, a[href*="/collections/"]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/collections/gift-boxes') !== -1 || href.indexOf('/collections/byo-brats') !== -1) {
        a.style.display = 'none';
      }
    });
  }

  function hardenByoProductPage() {
    if (!/\/products\/build-your-own-brat-box\/?$/.test(window.location.pathname)) return;

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', goBuilder, true);
      var submit = form.querySelector('[type="submit"], button[name="add"], .product-form__submit, [name="add"]');
      if (submit) {
        submit.addEventListener('click', goBuilder, true);
        try {
          if (submit.tagName === 'BUTTON') submit.textContent = 'Build your box — pick 6 flavors';
          if (submit.tagName === 'INPUT') submit.value = 'Build your box — pick 6 flavors';
        } catch (_) {}
      }
    });

    document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (el) {
      el.style.display = 'none';
    });

    var banner = document.createElement('div');
    banner.setAttribute('role', 'status');
    banner.style.cssText =
      'margin:1rem 0;padding:1rem 1.15rem;border:1px solid #c45c26;background:#fff7f2;color:#1a1410;font-size:.95rem;line-height:1.4';
    banner.innerHTML =
      '<strong>Flavor picks required.</strong> This box is hand-packed — ' +
      '<a href="' +
      BUILDER +
      '" style="color:#c45c26;text-decoration:underline">pick any 6 flavors</a> first ($44.99).';
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && form.parentNode) form.parentNode.insertBefore(banner, form);
  }

  function hardenGiftBoxesCollection() {
    if (/\/collections\/(gift-boxes|byo-brats)\/?$/.test(window.location.pathname)) {
      window.location.replace(BUILDER);
    }
  }

  function interceptCartAdd() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function') return;

    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && /\/cart\/add(\.js)?/.test(url) && init && init.body) {
          var body = init.body;
          var parsed = null;
          if (typeof body === 'string') {
            try {
              parsed = JSON.parse(body);
            } catch (_) {
              parsed = null;
            }
          }
          if (parsed) {
            var id = parsed.id || (parsed.items && parsed.items[0] && parsed.items[0].id);
            var props = parsed.properties || (parsed.items && parsed.items[0] && parsed.items[0].properties) || {};
            var propKeys = props && typeof props === 'object' ? Object.keys(props) : [];
            if (isByoVariant(id) && propKeys.length === 0) {
              window.location.href = BUILDER;
              return Promise.reject(new Error('BYO box requires flavor picks'));
            }
          }
        }
      } catch (_) {}
      return nativeFetch.apply(this, arguments);
    };
  }

  function boot() {
    rewriteLinks();
    hideHelperCollectionCards();
    hardenGiftBoxesCollection();
    hardenByoProductPage();
    interceptCartAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  setTimeout(rewriteLinks, 500);
  setTimeout(rewriteLinks, 1500);
  setTimeout(hideHelperCollectionCards, 500);
})();
